<template>
  <div id="app">
    <keep-alive>
      <router-view class="view" v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view class="view" v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>
<script>
export default {
  data() {
    // 这里存放数据
    return {};
  },
  created() {
    if (
      sessionStorage.getItem("webIp") == null ||
      sessionStorage.getItem("webIp") == ""
    ) {
      this.getWebIp();
    }
  },
  methods: {
    getWebIp() {
      try {
        let res = DataApi.getUserIpConfig();
        if (res.status === 0) {
          sessionStorage.setItem("webIp", res.result.ip);
        } else {
          sessionStorage.setItem("webIp", "103.43.184.186");
        }
      } catch (error) {
        sessionStorage.setItem("webIp", "103.43.184.186");
      }
    }
  }
};
</script>
<style scoped>
* {
  margin: 0;
  padding: 0;
  font-family: Microsoft YaHei;
  color: #333333;
}

html,
body {
  width: 100%;
  height: 100%;
  font-family: Microsoft YaHei;
  color: #333333;
}

#app {
  font-size: 14px;
}
</style>
